interface Props {
  mesaj: string;
  onChange: (m: string) => void;
}

export const sablonlar = [
  {
    key: 'bakim',
    label: 'Bakım Hatırlatma',
    ikon: 'ri-time-line',
    metin: 'Sayın [MÜŞTERİ ADI], su arıtma cihazınızın filtre bakım süresi dolmuştur. Sağlıklı su içmeye devam etmek için en kısa sürede servisimizle iletişime geçmenizi öneririz. Sadem Su Arıtma - 0212 XXX XX XX',
  },
  {
    key: 'filtre',
    label: 'Filtre Değişim',
    ikon: 'ri-filter-3-line',
    metin: 'Sayın [MÜŞTERİ ADI], cihazınızın filtrelerini değiştirme zamanı geldi. Eski filtreler su kalitesini olumsuz etkiler. Randevu almak için bizi arayabilirsiniz. Sadem Su Arıtma - 0212 XXX XX XX',
  },
  {
    key: 'kampanya',
    label: 'Özel Kampanya',
    ikon: 'ri-percent-line',
    metin: 'Sayın [MÜŞTERİ ADI], bu ay tüm filtre değişimlerinde %20 indirim fırsatı! Fırsatı kaçırmamak için hemen arayın. Sadem Su Arıtma - 0212 XXX XX XX',
  },
  {
    key: 'acil',
    label: 'Acil Bakım Uyarısı',
    ikon: 'ri-alarm-warning-line',
    metin: 'Sayın [MÜŞTERİ ADI], su arıtma cihazınızın bakımı kritik seviyeyi geçmiştir. Kullanıma devam etmek sağlığınızı tehdit edebilir. Lütfen en kısa sürede servis randevusu alınız. Sadem Su Arıtma - 0212 XXX XX XX',
  },
];

const MAX_CHAR = 500;

export default function MesajEditor({ mesaj, onChange }: Props) {
  const charCount = mesaj.length;
  const smsCount = Math.ceil(charCount / 160) || 1;
  const isOver = charCount > MAX_CHAR;

  return (
    <div className="space-y-4">
      {/* Şablon seçici */}
      <div>
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Hazır Şablonlar</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
          {sablonlar.map(s => (
            <button
              key={s.key}
              type="button"
              onClick={() => onChange(s.metin)}
              className="flex items-center gap-2 px-3 py-2.5 rounded-xl border border-gray-200 bg-white hover:border-sky-300 hover:bg-sky-50 transition-all cursor-pointer text-left group"
            >
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className={`${s.ikon} text-gray-400 group-hover:text-sky-500 text-sm`}></i>
              </div>
              <span className="text-xs font-medium text-gray-600 group-hover:text-sky-700">{s.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Textarea */}
      <div>
        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Mesaj İçeriği</p>
        <div className="relative">
          <textarea
            className={`w-full border rounded-xl px-4 py-3.5 text-sm text-gray-800 focus:outline-none focus:ring-1 resize-none bg-white leading-relaxed
              ${isOver
                ? 'border-red-300 focus:border-red-400 focus:ring-red-200'
                : 'border-gray-200 focus:border-sky-400 focus:ring-sky-200'}`}
            rows={6}
            value={mesaj}
            onChange={e => e.target.value.length <= MAX_CHAR && onChange(e.target.value)}
            placeholder="Mesajınızı buraya yazın veya yukarıdan bir şablon seçin..."
          />
          <div className="absolute bottom-3 right-3 flex items-center gap-2">
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full
              ${isOver ? 'bg-red-100 text-red-600' : charCount > 400 ? 'bg-yellow-100 text-yellow-600' : 'bg-gray-100 text-gray-400'}`}>
              {charCount}/{MAX_CHAR}
            </span>
          </div>
        </div>
        <div className="flex items-center justify-between mt-1.5">
          <p className="text-xs text-gray-400">
            <i className="ri-information-line mr-1"></i>
            <span className="font-medium">[MÜŞTERİ ADI]</span> ifadesi gönderim sırasında otomatik değiştirilir
          </p>
          <p className="text-xs text-gray-400">{smsCount} SMS</p>
        </div>
      </div>

      {/* Önizleme balonu */}
      {mesaj.trim() && (
        <div>
          <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Önizleme</p>
          <div className="bg-slate-100 rounded-2xl p-4 max-w-sm">
            <div className="bg-white rounded-xl rounded-tl-none px-4 py-3 text-sm text-gray-700 leading-relaxed whitespace-pre-wrap break-words">
              {mesaj.replace('[MÜŞTERİ ADI]', 'Ahmet Bey')}
            </div>
            <p className="text-xs text-gray-400 mt-2 text-right">Örnek önizleme — Ahmet Bey</p>
          </div>
        </div>
      )}
    </div>
  );
}
